import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, toRef } from 'vue';
import { useAlarmSetting } from '@blade-sxp/monitoring-center/pages/preview/utils/useAlarmSetting';
import DeviceCascader from '@blade-sxp/monitor-center/pages/components/dialog/device-cascader.vue';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
export default /*#__PURE__*/ _defineComponent({
    __name: 'alarm-setting-dialog',
    props: {
        dialogVisible: { type: Boolean },
        msg: null
    },
    emits: ['update:dialogVisible'],
    setup(__props, { emit }) {
        const props = __props;
        const store = useMonitoringStore();
        const fullScreen = computed(() => store.fullScreen);
        const escfullScreenStatus = computed(() => store.escfullScreenStatus);
        const dialogVisible = toRef(props, 'dialogVisible');
        const msg = toRef(props, 'msg');
        const ruleForm = ref(null);
        const result = ref(true);
        const { loading, form, visible, rules, changeCascader, getBaseConfig, onSubmit, cancelDialog } = useAlarmSetting(msg, dialogVisible, ruleForm, emit);
        // 获取基础配置
        getBaseConfig();
        return { __sfc: true, props, store, fullScreen, escfullScreenStatus, dialogVisible, msg, ruleForm, result, emit, loading, form, visible, rules, changeCascader, getBaseConfig, onSubmit, cancelDialog, DeviceCascader };
    }
});
